import {
  ReconciliationFilled,
  ReloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Button, Input, Select } from "antd";
import React, { useCallback, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { CustomLabel } from "../../../utilities/utll";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";
import { useBarCodeMasterStore } from "../../../store/useBarCodeStore";

export const FormSection = () => {
  const { editRow, updateEditRow, fetchDepartment, errors } =
    useBarCodeMasterStore();
  const { getDepartment, department, getCategory, category } =
    useVendorMasterStore();
  useEffect(() => {
    getCategory();
  }, []);
useEffect(() => {
  if (!editRow.divisionCode || category.length === 0) return;

  const divisionObj = category.find(
    (c) => String(c.Division) === String(editRow.divisionCode)
  );

  if (divisionObj) {
    updateEditRow("divisionName", divisionObj.DivisionName);
  }

  // department load karo
  fetchDepartment(editRow.divisionCode, getDepartment);
}, [editRow.divisionCode, category]);

useEffect(() => {
  if (!editRow.departmentCode || department.length === 0) return;

  const deptObj = department.find(
    (d) => String(d.Department) === String(editRow.departmentCode)
  );

  if (deptObj) {
    updateEditRow("departmentName", deptObj.DepartmentName);
  }
}, [editRow.departmentCode, department]);

  return (
    <>
      <div className="tab-content">
        <Row>
          <Col xl={3} md={6}>
            <CustomLabel children={"Divison"} isImportnt={false} />
            <Select
              id="roletype"
              placeholder="Select "
              allowClear
              showSearch
              optionFilterProp="label"
              size="medium"
              style={{ width: "100%" }}
              value={editRow.divisionCode}
              options={category.map((c) => ({
                label: c.DivisionName,
                value: c.Division,
              }))}
              onChange={(val, opt) => {
                updateEditRow("divisionCode", val);
                updateEditRow("divisionName", opt?.label);

                updateEditRow("departmentCode", null);
                updateEditRow("departmentName", null);

                fetchDepartment(val, getDepartment);
              }}
            />
            {errors?.divisionCode && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.divisionCode}
              </span>
            )}
          </Col>
          <Col xl={3} md={6}>
            <CustomLabel children={"Department"} isImportnt={false} />
            <Select
              id="roletype"
              placeholder="Select "
              allowClear
              showSearch
              optionFilterProp="label"
              size="medium"
              style={{ width: "100%" }}
              value={editRow.departmentCode}
              options={department.map((d) => ({
                label: d.DepartmentName,
                value: d.Department,
              }))}
              onChange={(val, opt) => {
                updateEditRow("departmentCode", val);
                updateEditRow("departmentName", opt?.label);
              }}
            />
            {errors?.departmentCode && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.departmentCode}
              </span>
            )}
          </Col>
          <Col xl={3} lg={3} md={6} sm={12}>
            <CustomLabel children={"GRN_91_120"} isImportnt={false} />
            <Input
              name="vendorname"
              id="vendorname"
              type="text"
              placeholder="Enter Value"
              size="medium"
              value={editRow.GRN_91_120}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  updateEditRow("GRN_91_120", value);
                }
              }}
            />
            {errors?.GRN_91_120 && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.GRN_91_120}
              </span>
            )}
          </Col>
          <Col xl={3} lg={3} md={6} sm={12}>
            <CustomLabel children={"GRN_121_180"} isImportnt={false} />
            <Input
              name="vendorname"
              id="vendorname"
              type="text"
              placeholder="Enter Value"
              size="medium"
              value={editRow.GRN_121_180}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  updateEditRow("GRN_121_180", value);
                }
              }}
            />
            {errors?.GRN_121_180 && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.GRN_121_180}
              </span>
            )}
          </Col>
        </Row>
        <Row>
          <Col xl={3} lg={3} md={6} sm={12}>
            <CustomLabel children={"GRN_181_270"} isImportnt={false} />
            <Input
              name="vendorname"
              id="vendorname"
              type="text"
              placeholder="Enter Value"
              size="medium"
              value={editRow.GRN_181_270}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  updateEditRow("GRN_181_270", value);
                }
              }}
            />
            {errors?.GRN_181_270 && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.GRN_181_270}
              </span>
            )}
          </Col>
          <Col xl={3} lg={3} md={6} sm={12}>
            <CustomLabel children={"GRN_271_360"} isImportnt={false} />
            <Input
              name="vendorname"
              id="vendorname"
              type="text"
              placeholder="Enter Value"
              size="medium"
              value={editRow.GRN_271_360}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  updateEditRow("GRN_271_360", value);
                }
              }}
            />
            {errors?.GRN_271_360 && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.GRN_271_360}
              </span>
            )}
          </Col>
          <Col xl={3} lg={3} md={6} sm={12}>
            <CustomLabel children={"GRN_361_720"} isImportnt={false} />
            <Input
              name="vendorname"
              id="vendorname"
              type="text"
              placeholder="Enter Value"
              size="medium"
              value={editRow.GRN_361_720}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  updateEditRow("GRN_361_720", value);
                }
              }}
            />
            {errors?.GRN_361_720 && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {errors?.GRN_361_720}
              </span>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};
